const KEYURI = {

        // BACKEND_URI:"http://localhost:5000/api"

        //BACKEND_URI:'https://lobster-app-fvzbk.ondigitalocean.app/api'
    BACKEND_URI:'https://orca-app-ocw8h.ondigitalocean.app/api'
}

export default KEYURI

